import { render, staticRenderFns } from "./policySimulator.vue?vue&type=template&id=0a9605c9&scoped=true"
import script from "./policySimulator.vue?vue&type=script&lang=js"
export * from "./policySimulator.vue?vue&type=script&lang=js"
import style0 from "./policySimulator.vue?vue&type=style&index=0&id=0a9605c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9605c9",
  null
  
)

export default component.exports